import styled from "styled-components";
import { Box } from "orcs-design-system";

export const RelativeContainer = styled(Box)`
  position: relative;
  min-height: 20vh;
`;
